// extracted by mini-css-extract-plugin
export var bodyRow = "_cl-d";
export var cardColumns = "_cl-e";
export var ellipsesOverflow = "_cl-2";
export var flatBottomCorners = "_cl-3";
export var flatTopCorners = "_cl-4";
export var headerActionsDropdown = "_cl-f";
export var headerBottomRow = "_cl-c";
export var headerTopRow = "_cl-b";
export var orderDetailsWrapper = "_cl-0";
export var orderInfoContainer = "_cl-1";
export var productDetails = "_cl-9";
export var productImage = "_cl-5";
export var responsiveTable = "_cl-8";
export var shipmentContainer = "_cl-a";
export var tableBottomLeft = "_cl-6";
export var tableBottomRight = "_cl-7";
export var trackingLink = "_cl-g";